<template>
    <v-container fluid fill-height :style="'height: '+size+';'">
      <v-layout justify-center align-center>
        <v-progress-circular :indeterminate="true" size="64" color="accent" />
      </v-layout>
    </v-container>
</template>
<script>
export default {
	props : ["height"],
	data : function(){
		return {
			size : "500px"
		};
	},
	created : function(){
		if(this.height != undefined)
			this.size = this.height;
	},
}
</script>
